import React from 'react';
import { Checkbox } from '@economic/gaudi';
import Field, { FieldProps } from '../Field';

// 'as' must be an instance, anonymous functions are recreated each render
const CheckboxField = ({ child: Component, onChange, value, ...fieldProps }) => (
    <Component {...fieldProps} onChange={event => onChange(event.target.checked)} checked={value} />
);

export default function FieldCheckbox({ as, fieldClassName, ...props }: FieldProps<any>) {
    const Component = as || Checkbox;
    return (
        <Field
            {...props}
            as={CheckboxField as any}
            child={Component}
            fieldClassName={fieldClassName}
            label={props.label || <span className="field__label__placeholder" />}
        />
    );
}
